import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { LookupItem } from "../../Layout/Components/LookupItem";
import { ClinicalStatus } from "../Models/ClinicalStatus";

interface IProps {
    clinicalStatus: number;
}

export default function ClinicalStatusRow(props: IProps) {

    let clinicalStatusOptions: Array<LookupItem> = [];

    for (let key in ClinicalStatus) {
        let value = ClinicalStatus[key];
        clinicalStatusOptions.push({ id: parseInt(key), name: value })
    }

    return (
        <Row>
            <Col xs={12} lg={6}>
                <div className="fw-bolder mb-1 vc-font-size-smaller">Clinical Status<OverlayTrigger
                    placement={"right"}
                    delay={{ hide: 800 } as any}
                    overlay={<Tooltip>
                        <p><i className="las la-info-circle text-light"></i>ABPN is not a primary source verification.  Clinical status is self-reported by the physician.</p>
                    </Tooltip>}>
                    <i className="las la-info-circle"></i>
                </OverlayTrigger></div>
                <div className="vc-font-size-smaller">{ClinicalStatus[props.clinicalStatus]}</div>
                <br/>
            </Col>
        </Row>
    );
}